<div class="flex-row align-items-center">
  <ng-container *ngIf="aiAlgorithms; else fetching">
    <mat-form-field class="full-width">
      <mat-label>{{ 'label.select_ai_model' | translate }}</mat-label>
      <mat-select
        (selectionChange)="analystChange.emit($event.value)"
        [value]="analystSelected"
        [disabled]="!disclaimerAccepted"
        [compareWith]="compareAnalysts"
      >
        <mat-select-trigger *ngIf="analystSelected">
          <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: analystSelected }"></ng-container>
        </mat-select-trigger>
        <mat-option *ngFor="let aiAlgorithm of aiAlgorithms" [value]="aiAlgorithm">
          <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: aiAlgorithm }"></ng-container>
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="!editMode && !editingEnabled">{{ 'hint.read_only_analysis' | translate }}</mat-hint>
    </mat-form-field>
  </ng-container>
  <ng-template #fetching> {{ 'info.fetching' | translate }}... </ng-template>
</div>

<ng-template #optionTpl let-aiAlgorithm>
  <ng-container *ngIf="getStateFor(aiAlgorithm.id) as analysisState">
    <div class="flex-row align-items-center justify-content-between">
      <span class="state-indicator" [matTooltip]="executionState(analysisState)"
        [class.state-indicator--in-progress]="executionState(analysisState) === 'inProgress'"
        [class.state-indicator--analyzed]="executionState(analysisState) === 'analyzed'"
        [class.state-indicator--error]="executionState(analysisState) === 'error'">
      </span>
      <span class="analyst-name flex-grow-1 text-ellipsis" #nameTooltip="matTooltip" [matTooltip]="aiAlgorithm?.name"
        [matTooltipShowDelay]="1000" (mouseleave)="nameTooltip.hide()">
        {{ aiAlgorithm?.name }}
      </span>
      <span class="text-gray align-self-end">
        <small>{{ analysisState.updatedAt | date : 'dd/MM/yyyy, hh:mm a' }}</small>
      </span>
    </div>
  </ng-container>
</ng-template>
